<template>
  <div class="dealerships">
    <h1 class="page-title">
      Dealerships <span v-if="dealerships.length > 15">({{ dealerships.length }})</span>
    </h1>

    <ul class="page-actions">
      <li>
        <router-link class="button" to="/dealerships/new">Create Dealership</router-link>
      </li>
    </ul>
    <div class="page-content">
      <div class="container upper_header">
        <div class="fixed">
          <input v-model="searchValue"
                 name="searchValue"
                 type="text"
                 style="width: auto; height: 36px;"
                 placeholder="Search Dealership Name/ID"
                 @change="searchNameConfirm"
          />
          <div class="button upper_button"
               @click="searchNameConfirm"
          ><i class="svg -search" style="vertical-align: text-bottom;"></i>Search
          </div>
          <div class="button upper_button"
               @click="searchNameCancel"
          >Cancel
          </div>
          <select class="upper_select upper_button" name="LeaveType" selected="All"
                  @change="onChangeStatus($event)">
            <option value="0">All</option>
            <option value="1">Active last 30 days</option>
            <option value="2">Alive from 30 to 180 days</option>
            <option value="3">Inactive more then 180 days</option>
            <option value="4">No rendered</option>
          </select>

        </div>
      </div>
      <SimpleTable :columns="columns"
                   :table-data="NewData"
                   :sort-option="sortOption"
                   style="width: 100%;"/>

      <div class="paginationDiv">
        <div class="flex-item">
          <SimplePagination :total="maintable.length"
                            :page-index="pageIndex"
                            :page-size="pageSize"
                            @on-page-number-change="pageNumberChange"
                            @on-page-size-change="pageSizeChange"/>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mdiCheck, mdiCheckboxBlankCircle, mdiCloseCircleOutline, mdiWebCheck} from '@mdi/js';
import {mapState} from "vuex";
import { RouterLink } from "vue-router";

import auth from "@/helpers/auth";
import SimpleTable from "@/components/SimpleTable.vue";
import SimplePagination from "@/components/SimplePagination.vue";
import ToggleButton from "@/components/ToggleButton.vue";


function checknullorempty(str) {
  if (typeof str === "string" && str.length === 0) {
    return true;
  } else if (str === null) {
    return true;
  } else {
    return false;
  }
};

export default {
  components: {
    SimpleTable,
    SimplePagination,
    ToggleButton
  },
  beforeRouteEnter(to, from, next) {
    if (!auth.signedIn()) return next("/sign-in");
    next();
  },
  data: function () {
    return {
      "sortOption": {
        "sortChange": (params) => {
          console.log("sortChange::", params);
          this.sortChange(params);
        },
      },
      cellStyleOption: {
        bodyCellClass: ({row, column, rowIndex}) => {
        }
      },
      "columns": [
        {
          "align": "center",
          "field": "active",
          "width": 80,
          "key": 'z',
          "renderBodyCell": ({row, column, rowIndex}, h) => {
            const name = 'change_' + row.id;
            const active = !row.disable;
            return h(ToggleButton, {
              modelValue: active,
              value: active,
              onchange: () => this.onOffDealership(row),
              color: "#3370d1",
              name: name
            });
          },
          "title": "Off/On"
        },
        {
          "align": "left",
          "field": "name",
          "key": "a",
          "renderBodyCell": ({row, column, rowIndex}, h) => {
            const text = row[column.field];
            const id = row.id;
            const link = '/dealerships/' + id;
            return h(RouterLink, {to: link}, () => text);
          },
          "title": "Dealership Name",
          "sortBy": "asc"
        },
        {
          "field": "dealership_id",
          "key": "b",
          "title": "Dealership ID",
          "align": "center",
        },
        {
          "field": "last_render",
          "key": "bb",
          "title": "Last Render(days)",
          "align": "center",
          "renderBodyCell": ({row, column, rowIndex}, h) => {
            let color;
            if (Number(row[column.field]) < 30) {
              color = "#00FF14BF";
            } else if (Number(row[column.field]) < 180 && Number(row[column.field]) > 30) {
              color = "#FFD400FF";
            } else if (Number(row[column.field]) === 1000) {
              color = "#FF0000BF";
            } else {
              color = "#838080BF";
            }
            return h('p', {style: "display: flex;justify-content: center;"},
              h('svg', {width: "24", height: "24", viewBox: "0 0 24 24", fill: "none"},
                h('path', {d: mdiCheckboxBlankCircle, fill: color})
              ),
              row[column.field]
            );
          }
        },
        {
          "field": "email", "key":
            "c", "title":
            "Email",
          "width": 80,
          "align": "center",
          "renderBodyCell": ({row, column, rowIndex}, h) => {
            let email;
            if (checknullorempty(row.notification_emails) === true) {
              email = "[NULL]";
            } else {
              email = row.notification_emails[0];
            }
            return h('p', {}, email);
          }
        },
        {
          "field": "address_present",
          "key": "d",
          "align": "center",
          "width": 80,
          "renderBodyCell": ({row, column, rowIndex}, h) => {
            let statusicon;
            let color;
            if (checknullorempty(row.address) === true) {
              statusicon = mdiCloseCircleOutline;
              color = "red";
            } else {
              statusicon = mdiCheck;
              color = "green";
              if (row.address_confirmed === true) {
                statusicon = mdiWebCheck;
              }
            }
            return h('svg', {width: "24", height: "24", viewBox: "0 0 24 24", fill: "none"},
              h('path', {d: statusicon, fill: color})
            );
          },
          "title": "Address"
        },
        {
          "field": "hours_present",
          "key": "e",
          "width": 80,
          "align": "center",
          "renderBodyCell": ({row, column, rowIndex}, h) => {
            let statusicon;
            let color;
            if (checknullorempty(row.opening_hours) === true) {
              statusicon = mdiCloseCircleOutline;
              color = "red";
            } else {
              statusicon = mdiCheck;
              color = "green";
            }
            return h('svg', {width: "24", height: "24", viewBox: "0 0 24 24", fill: "none"},
              h('path', {d: statusicon, fill: color})
            );
          },
          "title": "Opening Hours"
        },
        {
          "field": "trade_present",
          "key": "f",
          "align": "center",
          "width": 80,
          "renderBodyCell": ({row, column, rowIndex}, h) => {
            let statusicon;
            let color;
            if (row.accepts_trade_ins === true) {
              statusicon = mdiCheck;
              color = "green";
            } else {
              statusicon = mdiCloseCircleOutline;
              color = "red";
            }
            return h('svg', {width: "24", height: "24", viewBox: "0 0 24 24", fill: "none"},
              h('path', {d: statusicon, fill: color})
            );
          },
          "title": "Trade-ins"
        },
        {
          "field": "finance_available",
          "key": "g",
          "align": "center",
          "width": 80,
          "renderBodyCell": ({row, column, rowIndex}, h) => {
            let statusicon;
            let color;
            if (row.finance_available === true) {
              statusicon = mdiCheck;
              color = "green";
            } else {
              statusicon = mdiCloseCircleOutline;
              color = "red";
            }
            return h('svg', {width: "24", height: "24", viewBox: "0 0 24 24", fill: "none"},
              h('path', {d: statusicon, fill: color})
            );
          },
          "title": "Finance"
        },
      ],
      // page index
      "pageIndex": 1,
      // page size
      "pageSize": 10,
      "maintable": [],
      "searchValue": '',
    };
  },
  computed: {
    ...mapState({
      dealerships: (state) => state.dealerships.all
    }),
    database: {
      set: function (val) {
        this.maintable = val;
        // If necessary, also copy val into an external variable here
      },
      get: function () {
        console.info("get data");

        return this.maintable;
      }
    },
    NewData() {
      const {pageIndex, pageSize} = this;
      return this.database.slice(
        (pageIndex - 1) * pageSize,
        pageIndex * pageSize
      );
    }
  },

  mounted() {
    this.maintable = this.dealerships;
    console.log(this.dealerships);
  },

  methods: {
    onOffDealership(params) {
      this.switch(params);
      params.disable = !params.disable;
      console.log('ON_OFF' + params.id);
    },
    // page number changes
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
    },

    // page size change
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
    },
    onChangeStatus(event) {
      if (event.target.value === '0') {
        this.maintable = this.dealerships;
      }
      if (event.target.value === '1') {
        console.log(this.dealerships.filter((x) => Number(x.last_render) <= 30));
        this.maintable = this.dealerships.filter((x) => Number(x.last_render) <= 30);
      }
      if (event.target.value === '2') {
        this.maintable = this.dealerships.filter((x) => Number(x.last_render) < 180 && Number(x.last_render) > 30);
      }
      if (event.target.value === '3') {
        this.maintable = this.dealerships.filter((x) => Number(x.last_render) < 1000 && Number(x.last_render) > 180);
      }
      if (event.target.value === '4') {
        this.maintable = this.dealerships.filter((x) => Number(x.last_render) === 1000);
      }
      console.log(event.target.value);
    },
    searchName(search) {
      const searchValue = search;
      this.maintable = this.maintable.filter(
        (x) =>
          !searchValue.length ||
          x.name.toLowerCase().includes(searchValue.toLowerCase()) ||
          x.dealership_id.toLowerCase().includes(searchValue.toLowerCase()),
      );
    },
    // search cancel
    searchNameCancel() {
      this.maintable = this.dealerships;
    },

    // search cancel
    searchNameConfirm() {
      this.searchName(this.searchValue);
    },
    sortChange(params) {
      let data;
      // eslint-disable-next-line prefer-const
      data = this.database.slice(0);

      // eslint-disable-next-line array-callback-return
      data.sort((a, b) => {
        if (params.name) {
          if (params.name === "asc") {
            console.log("asc");
            return a.name.localeCompare(b.name);
          } else if (params.name === "desc") {
            console.log("desc");
            return b.name.localeCompare(a.name);
          } else {
            return 0;
          }
        }
      });

      this.database = data;
    },
    switch(data) {
      this.$store
        .dispatch("switchDealershipAPI", data);
    }
  }
};

</script>

<style>
input[type="text"],
input[type="submit"],
select,
textarea {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 100%;
  margin: 5px 0 15px;
  border-radius: 4px;
  border: 1px solid #ddd;
}

.button {
  display: inline-block;
  background: #487fd6;
  color: #fff;
  margin: 5px 1px 15px;
  text-decoration: none;
  border-radius: 4px;
  text-align: center;
  width: fit-content;
  padding: 0px 10px;
}

div.container {
  display: flex;
}

div.upper_header {
  padding-left: 90px;
  margin-bottom: 20px;
}

div.fixed {
  display: flex;
  float: left;
  padding-top: 12px;
  height: 60px;
  width: auto;
}

div.flex-item {
  flex-grow: 1;
  float: right;
  text-align: end;
}

.upper_button {
  margin-left: 12px;
  height: 36px;
  width: max-content;
  padding-top: 3px;
  display: flex;
  vertical-align: middle;
}

.upper_select {
  background-position: right 14px top 11px;
  width: 245px;
}

div.upper_button:hover {
  background-color: #3b6bbf;
}
</style>
